<script>
export let x;
export let y;
export let text;
export let halo = false;
export let anchor = 'middle';
</script>

<g class="line-anno" transform="translate({x},{y})">
  {#if halo}
  <g class="line-anno-label line-anno-label-halo">
    <text dx="14" dy="17" class="line-anno-label-value">
      {text}
    </text>
  </g>
  {/if}
  <g class="line-anno-label">
    <text dx="14" dy="17" class="line-anno-label-value" style="font-weight: 400; text-anchor: {anchor};">
      {text}
    </text>
  </g>
</g>
